<template>
  <div>
    <div>
      <div class="alert alert-info mt-3">
        <div class="row">
          <div class="col-1 d-flex border-right">
            <icon :icon="['fad', 'info']" class="text-info fa-3x mx-auto my-auto"/>
          </div>
          <div class="col">
            Every abstract submission is charged with a EUR 83,30 (including 19% VAT) fee, which can be either paid by bank transfer or
            credit card. The fee is not refundable, regardless of the acceptance of the abstract.<br>
            Please click on the "Pay abstract fee" button to process the payment.<br>
            Abstract submissions will only be considered as fully completed upon receipt of the registration and abstract fee payment.<br>
            You will receive an invoice per email once the payment has been processed.<br>
            <br>
            For questions regarding the payment, please refer to <a
              href="mailto:fensforum_abstracts@kit-group.org">fensforum_abstracts@kit-group.org</a>.
          </div>
        </div>
      </div>
      <button class="btn btn-success" @click="checkout">
        <!--icon :icon="['fab', 'cc-stripe']"/-->
        Pay abstract fee
      </button>
    </div>
    <div class="row mt-4">
      <div class="col d-flex">
        <router-link
            :to="previousSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)"
            class="mr-auto">
          <button type="button" class="btn btn-info">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            {{ wording[0].buttons.back }}
          </button>
        </router-link>
        <router-link
            :to="nextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)"
            class="ml-auto"
            v-if="hasNextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)">
          <button type="button" class="btn btn-info float-right">{{ wording[0].buttons.next }}
            <icon :icon="['fas', 'angle-right']" size="lg"/>
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {StripeCheckout} from '@vue-stripe/vue-stripe';
import {mapGetters, mapState} from "vuex";

export default {
  components: {
    StripeCheckout
  },
  data: () => ({
    loading: false,

    publishableKey: 'pk_test_NJ0lEhm4OOTKhji9QIFncU3f00CZDeEslD',  // test
    items: [
      {
        sku: 'sku_FfCMBiTbqErrJE',      // test
        quantity: 1
      }
    ],
    routepath: window.location,
  }),
  created() {
    if (this.abstract.paid === true || this.abstract.payment_process === true) {
      this.$router.push('payment/success/' + this.abstract.payment_transfer);
    }
  },
  computed: {
    ...mapState([
      'user', 'wording', 'settings', 'processing', 'abstract'
    ]),
    ...mapGetters([
      'getCurrentPages', 'getCurrentPageById', 'getCurrentPageByType'
    ]),
  },
  methods: {
    checkout() {
      //this.$refs.checkoutRef.redirectToCheckout();
      let parameter;
      parameter = "abstract_id=" + this.abstract.id + "&successUrl=" + this.routepath + "/success" + "&cancelUrl=" + this.routepath;
      // console.log(parameter);
      parameter = encodeURI(parameter);
      parameter = btoa(parameter);
      //console.log(this.user['extra']['kit2']['userInfo']['paymentURL']+'&token='+parameter);
      if (this.user['extra']['kit2']['userInfo']['paymentURL']) {
        window.location = this.user['extra']['kit2']['userInfo']['paymentURL'] + '&token=' + parameter;
      }
    },
  }
}
</script>
